module.exports = __webpack_public_path__ + "static/media/ic-tag-and-organize.355ecfc5.svg";